export default {"src":"/_next/static/media/ic_right_white.80993b3a.svg","height":352,"width":192,"blurWidth":0,"blurHeight":0};